var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "17",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("g", { attrs: { "clip-path": "url(#a)" } }, [
        _c("path", {
          attrs: {
            fill: "#E1E3E7",
            d:
              "M15.928 1.567H1.47C.793 1.567 0 2.347 0 3.037v11.02c0 .69.793 1.47 1.47 1.47h18.367c.676 0 1.47-.78 1.47-1.47V8.525a4.393 4.393 0 0 1-2.205 1.065v.059c0 .485-.264.735-.735.735H2.204c-.47 0-.735-.25-.735-.735v-.735c0-.485.265-.734.735-.734h12.88a4.394 4.394 0 0 1 .844-6.613Z"
          }
        }),
        _c("path", {
          attrs: {
            fill: "#000",
            d: "M14.209 3.771H0v2.205h14.018a4.436 4.436 0 0 1 .191-2.205Z"
          }
        })
      ]),
      _c("path", {
        attrs: {
          fill: "#000",
          d:
            "M18.857 10.286a5.143 5.143 0 1 1 0-10.286 5.143 5.143 0 0 1 0 10.286Zm-2.042-7.274h-.58l-1.419.72v.735l1.124-.588v3.394h.882v-4.26h-.007Zm1.69.588c.418 0 .712.235.712.573 0 .367-.345.625-.845.625h-.22v.624h.264c.53 0 .89.265.89.647 0 .367-.353.617-.853.617-.367 0-.735-.118-1.117-.346v.735c.412.176.823.272 1.227.272.963 0 1.624-.492 1.624-1.205 0-.5-.309-.904-.823-1.065.44-.147.727-.537.727-.977 0-.691-.61-1.161-1.491-1.161-.397.004-.79.09-1.154.25v.72c.353-.199.713-.309 1.058-.309Zm3.173 1.602c.537 0 .911.316.911.727 0 .433-.374.735-.91.735-.324 0-.662-.103-1.007-.316v.756c.36.162.727.243 1.087.243.191 0 .367-.03.537-.074a4.033 4.033 0 0 0 .602-2.115l-.015-.309a1.69 1.69 0 0 0-.903-.235c-.133 0-.272.007-.42.03v-.956h1.059a4.131 4.131 0 0 0-.338-.676h-1.484v2.315c.294-.074.587-.125.881-.125Z"
        }
      }),
      _c("defs", [
        _c("clipPath", { attrs: { id: "a" } }, [
          _c("path", { attrs: { fill: "#fff", d: "M0 1.567h23.51v15.43H0z" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }